import { Box, styled } from "@mui/material";

export const UploadItemStyled = styled(Box)(({ theme: { palette } }) => ({
  background: palette.custom.blue[50],
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  padding: "16px 16px",
  borderRadius: "14px",
  alignItems: "center",
  transitionDuration: "0.2s",
  "&:hover": {
    boxShadow: "0px 6px 6px 0px rgba(0,0,0,0.1)",
    background: palette.custom.blue[100],
  },
  "& .MuiTypography-subtitle1": {
    fontSize: 14,
    lineHeight: "19.6px",
  },
  "& .MuiTypography-body2": {
    fontSize: 12,
    color: "#00000099",
  },
}));

export const UploadItemIcon = styled(Box)({
  padding: "3px",
  background: "white",
  borderRadius: "50%",
  height: 40,
  width: 40,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  marginRight: "10px",
});
